import React, { FC, useState } from 'react'
import { FormikHelpers } from 'formik'
import { push } from 'connected-react-router'

import Form from '../../components/Form'
import Link from '../../components/UI/Link/Link'
import TextInput from '../../components/UI/Inputs/TextInput'
import CustomButton from '../../components/UI/Buttons/CustomButton'
import { TForgotPassFormValues } from '../../models/form'

import { forgotPasswordThunk } from '../../store/auth/thunks'
import { useDispatch, useSelector } from '../../store'
import { NON_AUTH_ROUTE } from '../App/routes'

interface CalendarProps {}

const Calendar: FC<CalendarProps> = (props) => {
  const inProgress = useSelector((state) => state.auth.inProgress)
  const [isSentEmail, setIsSentEmail] = useState<boolean>(false)
  const dispatch = useDispatch()

  const setUpForm = {
    initialValues: { email: '' },
    validation: 'user',
    onSubmit: async (
      values: TForgotPassFormValues,
      actions: FormikHelpers<TForgotPassFormValues>
    ) => {
      await dispatch(forgotPasswordThunk(values))
      setIsSentEmail(true)
    }
  }

  return (
    <div className='agency-creation-step animation-container'>
      <div
        className={`animation-container_item ${
          !isSentEmail ? 'animation-container_item_hidden' : 'animation-container_item_visible'
        }`}
      >
        <div className='agency-creation-step__description '>
          An email has been sent to your email address with instructions to reset your password
        </div>
        <Link text='Go back' linkTo={NON_AUTH_ROUTE.LOGIN} className='agency-creation-step__link' />
      </div>
      <div
        className={`animation-container_item ${
          isSentEmail ? 'animation-container_item_hidden' : 'animation-container_item_visible'
        }`}
      >
        <div className='agency-creation-step__title'>Forgot password</div>
        <div className='agency-creation-step__description'>
          Enter your email and we will send you a reset link
        </div>
        <Form {...setUpForm}>
          <TextInput label='Email' name='email' type='email' placeholder='Enter your email' />
          <CustomButton inProgress={inProgress} button='primary' size='big' type='submit'>
            Submit
          </CustomButton>
        </Form>
        <Link text='Go back' linkTo={NON_AUTH_ROUTE.LOGIN} className='agency-creation-step__link' />
      </div>
    </div>
  )
}

export default Calendar
